import React, { useState } from 'react';
import Checklist from 'SharedComponents/Checklist';
import useTranslate from 'Hooks/useTranslate';
import { Badge } from 'SharedComponents/styled/overlay/Badge';
import DefaultWWLogo from 'Assets/wwlogo.svg';
import { Logo } from 'SharedComponents/styled/overlay/Logo';
import { UspBlock } from 'SharedComponents/styled/overlay/UspBlock';
import { MobileOnlyTitle } from 'SharedComponents/styled/overlay/Title';

interface RegisterHeaderWrapperProps {
    logo?: string;
}

const RegisterHeaderWrapper: React.FunctionComponent<RegisterHeaderWrapperProps> = ({ logo }) => {
    const [activeLogo, setActiveLogo] = useState(logo || DefaultWWLogo);
    const { t } = useTranslate();
    return (
        <>
            <Logo
                src={activeLogo}
                alt="Westwing"
                onError={() => setActiveLogo(DefaultWWLogo)}
                isDefaultLogo={activeLogo === DefaultWWLogo}
                extraPadding
            />
            <>
                <MobileOnlyTitle>{t('signupOverlay_mobile signup title')}</MobileOnlyTitle>
                <Badge isCenterPlaced={false}>{t('signupOverlay_Badge text')}</Badge>
                <UspBlock className="qa-signup-overlay__usp-block" isSmall={false} isCentralAligned={false}>
                    <Checklist
                        items={[
                            { id: 'signupOverlay_USP1', node: t('signupOverlay_USP1') },
                            { id: 'signupOverlay_USP2', node: t('signupOverlay_USP2') },
                            { id: 'signupOverlay_USP3', node: t('signupOverlay_USP3') },
                        ]}
                    />
                </UspBlock>
            </>
        </>
    );
};

export default RegisterHeaderWrapper;
